import { LibraryAPI } from '@business/api/library';
import { tap } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { BehaviorSubject } from 'rxjs';
import { CompactLibraryItemResponse } from '@business/entities/library';
import { OrgChartBlockVariation } from './OrgChartBlock';

export class OrgChartBlockBloc extends BaseBloc {
  constructor(private variation: OrgChartBlockVariation) {
    super();
  }

  items$ = new BehaviorSubject<CompactLibraryItemResponse[] | null>(null);
  readonly loading = new LoadingState({ loading: false });

  onInit() {
    return LibraryAPI.getLibraryItems(this.variation).pipe(tap(data => this.items$.next(data)));
  }
}
